import React, { useEffect, useRef, useState } from 'react';

const AnimatedCounter = ({ target, duration = 1500, suffix = '', prefix = '' }) => {
  const initialValue = parseInt(target) || 0;
  const [count, setCount] = useState(initialValue);
  const ref = useRef();
  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    if (!window.IntersectionObserver) return;
    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const observer = new window.IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated) {
          setHasAnimated(true);
          if (reduce) {
            // respect reduced motion: just show the target, no animation
            setCount(parseInt(target) || 0);
          } else {
            setCount(0); // reset to animate up once visible
          }
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => observer.disconnect();
  }, [hasAnimated, target]);

  useEffect(() => {
    if (!hasAnimated) return;
    let start = 0;
    const end = parseInt(target);
    if (isNaN(end)) return;
    const increment = end / (duration / 16);
    let current = start;
    const step = () => {
      current += increment;
      if (current < end) {
        setCount(Math.floor(current));
        requestAnimationFrame(step);
      } else {
        setCount(end);
      }
    };
    requestAnimationFrame(step);
  }, [hasAnimated, target, duration]);

  return (
    <span ref={ref}>
      {prefix}{count.toLocaleString()}{suffix}
    </span>
  );
};

export default AnimatedCounter; 